export function isGoogleAvailable(timeout: number = 5000) {
  return new Promise((resolve) => {
    // 设置图像加载超时
    const timeoutId = setTimeout(() => resolve(false), timeout);

    const img = new Image();
    img.onload = () => {
      clearTimeout(timeoutId);
      resolve(true);
    };
    img.onerror = () => resolve(false);

    // 随机加载不同国家Google的LOGO（增加可用性）
    const countries = ['com', 'co.uk', 'de', 'fr', 'jp', 'ca', 'com.br'];
    const domain = countries[Math.floor(Math.random() * countries.length)];
    img.src = `https://www.google.${domain}/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png?t=${Date.now()}`;
  });
}

export const checkWithRetry = async (maxAttempts: number = 2) => {
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    const available = await isGoogleAvailable();
    if (available) return true;

    // 如果不是最后一次尝试则等待
    if (attempt < maxAttempts) {
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }
  }
  return false;
};

/**
 * 监听网络状态变化
 *
 * @param callback 状态变化时的回调函数
 * @returns 清理函数，用于移除事件监听器
 */
export const watchNetworkStatus = (callback: (isOnline: boolean) => void) => {
  // 服务端环境返回空的清理函数
  if (typeof window === 'undefined') return () => {};

  const controller = new AbortController();
  window.addEventListener('online', () => callback(true), {
    signal: controller.signal,
  });
  window.addEventListener('offline', () => callback(false), {
    signal: controller.signal,
  });

  // 返回清理函数
  return () => controller.abort();
};
